import { render, staticRenderFns } from "./DonutChartWidgetComponent.vue?vue&type=template&id=8cf89724&"
import script from "./DonutChartWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./DonutChartWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports